export const CP_TABLE = {
    SPIN_WIN_EASY: 10,
    SPIN_WIN_MEDIUM: 25,
    SPIN_WIN_HARD: 50,
    FLIP_CARD: 15,
    DAILY_CHALLENGE: 100,
    MISSION_COMPLETE: 200,
    BADGE_UNLOCKED: 500
  };
  
  export const LEVEL_CAP = 20;
  export const CP_PER_LEVEL = 1000;
  
  export const BADGES = [
    { id: 'b_first_win', name: 'First Blood', desc: 'Win your first spin', icon: '🩸', req: (stats) => stats.wins >= 1 },
    { id: 'b_high_roller', name: 'High Roller', desc: 'Bet over $1000 in one go', icon: '💸', req: (stats) => stats.maxBet >= 1000 },
    { id: 'b_scholar', name: 'Scholar', desc: 'Flip 50 cards total', icon: '📖', req: (stats) => stats.cardsFlipped >= 50 },
    { id: 'b_veteran', name: 'Veteran', desc: 'Reach Level 10', icon: '⭐', req: (stats) => stats.level >= 10 },
    { id: 'b_sniper', name: 'Syntax Sniper', desc: 'Win 5 Hard rounds in a row', icon: '🎯', req: (stats) => stats.hardStreak >= 5 },
  ];